<template>
    <v-container>
            <v-form ref="form" lazy-validation>
                <v-row>
                <v-col>
                    <v-select
                        v-model="searchItem"
                        :items=searchItems
                        @change="onSearchItemChange"
                        item-text="text"
                        item-value="value"
                        id="search"
                        label="ค้นหา"
                        outlined
                    >
                    </v-select>
                </v-col>
                <v-col >
                    <DatePicker v-if="searchItem == 1"  label="วันที่รับอะไหล่" @dateFormatted="setDate" ></DatePicker>
                    <v-text-field  ref="searchValue"  @keyup.enter.native="search" :error="isError" v-else v-model="searchValue" :label="searchValueLabel"  placeholder="กรอกข้อมูลคำค้น" outlined></v-text-field></v-col>
                <v-col class="text-right">
                     <div class="mx-2">
                        <v-toolbar class="d-flex justify-end" flat color="white">
                            <v-btn  class="ma-2" color="primary" small @click="search"><v-icon>search</v-icon> ค้นหา</v-btn>
                            <AddParts :branchCode="branchCode" @saved="search"></AddParts>
                        </v-toolbar>
                     </div>
                    
                </v-col>
            </v-row>
            </v-form>
        <v-data-table
            v-model="itemSelected"
            :headers="headers"
            :items="items"
            item-key="receivePartsDetailId"
            show-select
            class="pt-5"
            >

            <template v-slot:top>
                <v-toolbar-title><v-btn v-if="itemSelected.length > 0"  class="ma-2" color="primary" small @click="deleteSelected"><v-icon>delete</v-icon> ลบรายการที่เลือก</v-btn></v-toolbar-title>
                <v-dialog v-model="viewDialog">
                    <ViewParts ref="viewParts" :id="itemId"  @closeViewParts="closeViewParts"></ViewParts>
                </v-dialog>
                    
            </template>

            <template v-slot:item.action="{ item }">
                <v-icon
                    v-if="item.jobNo == undefined || item.jobNo.length == 0"
                    small
                    @click="editData(item)"
                >
                    edit
                </v-icon>
                <v-icon
                    v-else
                    small
                    @click="editData(item)"
                >
                    search
                </v-icon>
                &nbsp;
                <v-icon
                    small
                    @click="deleteData(item)"
                >
                    delete
                </v-icon>
            </template>
        </v-data-table>
    </v-container>
    
</template>

<script>

import DatePicker from '@/components/Shared/DatePicker'
import {listStockParts, deleteDetailStock} from '@/api/stock/stock-parts-api.js'
import ViewParts from './ViewParts'
import AddParts from './AddParts'
export default {
    name: 'Search',
    components: {
        DatePicker,
        ViewParts,
        AddParts
    },
    computed: {
        searchValueLabel() {
            return this.isError ? "กรุณากรอกข้อมูลคำค้น" : "";
        }
    },
    watch: {
        branchCode(val) {
            if (val) {
                this.search();
            }
        }
    },
    props: ["branchCode"],
    data: () => ({
        viewDialog: false,
        itemSelected: [],
        headers: [
            {text: "เลขที่ใบสั่งซ่อม", value: "jobNo"},
            {text: "ทะเบียน", value: "licenseNo"},
            {text: "วันที่รับอะไหล่", value: "receiveDate"},
            {text: "ชื่ออะไหล่", value: "partsNameDisplay"},
            {text: "จำนวน", value: "qty"},
            {text: "ยอดรวม", value: "netAmount"},
           // {text: "ผู้รับ", value: "receiver"},
            {text: 'Actions', value: 'action', sortable: false}
        ],
        items: [

        ],
        searchItems: [{text: 'วันที่รับอะไหล่', value: 1},
            {text: "เลขที่ใบสั่งซ่อม", value: 2},
            {text: "หมายเลขอะไหล่", value: 3}],
        searchItem: 1,
        date: null,
        searchValue: '',
        isError: false,
        itemId: -1
    }),
    methods: {
        onSearchItemChange() {
            this.searchValue = '';
        },
        setDate(val) {
            this.searchValue = val;
        },
        addClick() {
            this.$emit("addClick");
        },
        search() {
            if (!this.searchValue) {
                this.isError = true;
                this.$refs.searchValue.focus();
                return;
            }
            let val = this.searchValue;
            if (this.searchItem == 1) {
                val = this.searchValue.replace("/", "-").replace("/", "-");
            }
            listStockParts(this.branchCode, this.searchItem, val).then(rs => {
                this.items = rs;
            });
        },
        editData(item) {
            this.itemId = item.receivePartsId;
            this.viewDialog = true;
            this.$nextTick(() => {
                this.$refs.viewParts.show(this.itemId);
            })
            
        },
        deleteData(item) {
            if (confirm('ต้องการลบ ' + item.partsName + ' ใช่หรือไม่ ?')) {
                deleteDetailStock(item.receivePartsId, item.receivePartsDetailId).then(() => {
                const index = this.items.indexOf(item);
                this.items.splice(index, 1);
            });
            }
            
        },
        deleteSelected() {
            if (confirm('ต้องการลบข้อมูลจำนวน ' + this.itemSelected.length + ' รายการ ใช่หรือไม่ ?')) {
                this.itemSelected.forEach(o => {
                    deleteDetailStock(o.receivePartsId, o.receivePartsDetailId).then(() => {
                        const index = this.items.indexOf(o);
                        this.items.splice(index, 1);
                    });
                });
                
                this.itemSelected = [];
            }
            
        },
        closeViewParts() {
            this.viewDialog = false;
            this.search();
        }
    }
}
</script>